import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { pageLoginService } from 'src/app/services/page-login/page-login.service';
import { PopupType } from './models/popupType.model';
import { PopupsInfo } from './models/popups-info.model';

@Component({
  selector: 'app-page-login-popups',
  template: ''
})
export class PageLoginPopupsComponent implements OnInit {

  @Output() popupsFirstConnection = new EventEmitter<PopupsInfo>();
  @Output() popupsInfo = new EventEmitter<PopupsInfo>();
  @Input() popupType: PopupType = PopupType.LOGIN
  constructor(private readonly pageLoginService: pageLoginService) { }

  ngOnInit(): void {
    this.getPopupInfo(this.popupType)
  }

  getPopupInfo(popupType) {
    if (popupType === PopupType.LOGIN_With_FIRST_CONNECTION) {
      this.pageLoginService.getPageLoginPopups(PopupType.FIRST_CONNECTION)
        .subscribe({
          next: (data) => {
            this.popupsFirstConnection.emit(data)
          }
        })
      this.pageLoginService.getPageLoginPopups(PopupType.LOGIN)
        .subscribe({
          next: (data) => {
            this.popupsInfo.emit(data)
          }
        })

    } else {
      this.pageLoginService.getPageLoginPopups(popupType)
        .subscribe({
          next: (data) => {
            this.popupsInfo.emit(data)
          }
        })
    }
  }
}
